import React from "react";
import logo from "../../assets/logo/logonew.png";
import { useNavigate } from "react-router-dom";
import { FaFacebook, FaTiktok, FaLinkedin, FaTwitter, FaYoutube } from "react-icons/fa";
import { CiInstagram } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { SiGmail } from "react-icons/si";

const Footer = () => {
  let getYear = () => {
    let currentYear = new Date().getFullYear();
    return currentYear;
  };

  return (
    <>
      <footer className="bg-charcoal text-linen border-t border-linen/10 font-sans mt-auto">
        <div className="max-w-7xl mx-auto px-6 py-12 md:py-16 grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          <div className="col-span-2 md:col-span-2 lg:col-span-1 space-y-4 md:space-y-6">
            <a href="/" className="inline-block opacity-90 hover:opacity-100 transition-opacity">
              <img src={logo} className="h-12 md:h-16 rounded-sm mb-3" alt="Weaving Hands Logo" />
              {/* <span className="font-serif tracking-widest text-lg md:text-xl uppercase block">Weaving Hands</span> */}
            </a>
            <p className="text-linen/60 text-xs md:text-sm font-light max-w-[220px]">
              Crafting timeless heirloom furniture with five generations of mastery.
            </p>
          </div>
          
          <div>
            <h3 className="font-serif italic tracking-wider mb-4 md:mb-6 text-lg md:text-xl text-brass">Our Atelier</h3>
            <ul className="space-y-1.5 md:space-y-2 text-xs md:text-sm text-linen/70 font-light flex flex-col">
              <span>No: 144, Barracka Street,</span>
              <span>Namalwarpet Ayanavaram,</span>
              <span>Chennai, Tamil Nadu 600012</span>
            </ul>
          </div>
          
          <div>
            <h3 className="font-serif italic tracking-wider mb-4 md:mb-6 text-lg md:text-xl text-brass">Explore</h3>
            <ul className="space-y-2 md:space-y-3 text-xs md:text-sm text-linen/70 font-light cursor-pointer">
              <li><a href="/" className="hover:text-brass transition-colors">Home</a></li>
              <li><a href="/furnitures" className="hover:text-brass transition-colors">Collections</a></li>
              <li><a href="/about" className="hover:text-brass transition-colors">Our Story</a></li>
              <li><a href="/contact" className="hover:text-brass transition-colors">Contact</a></li>
              <li><a href="/terms-conditions" className="hover:text-brass transition-colors">Terms & Conditions</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-serif italic tracking-wider mb-4 md:mb-6 text-lg md:text-xl text-brass">Connect</h3>
            <ul className="space-y-1.5 md:space-y-2 text-xs md:text-sm text-linen/70 font-light mb-4 md:mb-6">
              <span>Monday - Sunday</span>
              <span className="block">08:00 AM – 09:00 PM</span>
            </ul>
            <div className="flex gap-4 text-2xl">
              <a href="https://www.instagram.com/weaving_hand?igsh=MTZubmRrMjZyc2lrdA==" target="_blank" rel="noopener noreferrer" className="text-linen/70 hover:text-brass transition-colors">
                <CiInstagram />
              </a>
              <a href="tel:+919444161667" className="text-linen/70 hover:text-brass transition-colors">
                <IoCallOutline />
              </a>
              <a href="mailto:shankarcanefurniture@gmail.com" className="text-linen/70 hover:text-brass transition-colors">
                <SiGmail />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-linen/10 py-5">
          <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center text-[10px] md:text-xs text-linen/40 uppercase tracking-widest font-light gap-2 md:gap-0">
            <div className="mb-4 md:mb-0">
              © {getYear()} Weaving Hands. All Rights Reserved.
            </div>
            <div>
              Designed by{" "}
              <a href="https://makingmindstechnologies.com/" className="hover:text-brass hover:underline transition-colors">
                Making Minds Technologies
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
